/**
 * truncate text based on whether it contains full or halfwidth characters
 * @param text the string the be truncated
 * @param fullSizeLimit the max amount of characters to allow in a string containing ANY full-width characters
 * @param halfSizeLimit the max amount of character to allow in a string containg ONLY half-width characters
 * @returns the truncated text with the standard 3 trailing dots (e.g. "...")
 */
export const truncateText = (text: string, fullSizeLimit = 10, halfSizeLimit: number) => {
  // in the worst case, make full and half limits the same if the user didn't define a halfwidth limit
  if (!halfSizeLimit) halfSizeLimit = fullSizeLimit;

  if (text == null || !text) {
    return "";
  }

  if (text.match(/[一-龠ぁ-ゔァ-ヴーａ-ｚＡ-Ｚ０-９々〆〤]/g) && text.length > fullSizeLimit) {
    return text.substring(0, fullSizeLimit) + "...";
  } else if (text.length > halfSizeLimit) {
    return text.substring(0, halfSizeLimit) + "...";
  }

  return text;
};
